"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var classNames = require("classnames");
var React = require("react");
var monitoring_1 = require("../../services/monitoring");
var Icon_1 = require("../Icon/Icon");
var ProgressSpinner_1 = require("../ProgressSpinner/ProgressSpinner");
var pick_react_known_prop_1 = require("pick-react-known-prop");
var Button = /** @class */ (function (_super) {
    __extends(Button, _super);
    function Button() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.renderChildren = function () {
            var _a = _this.props, text = _a.text, children = _a.children, icon = _a.icon, iconSide = _a.iconSide, buttonType = _a.buttonType, loading = _a.loading;
            // Determine icon / progress spinner color by buttonType
            var iconColor = 'white';
            switch (buttonType) {
                case 'secondary':
                    iconColor = 'action';
                    break;
                case 'tertiary':
                    iconColor = 'space';
                    break;
                default:
                    break;
            }
            var largeIconButtons = {
                'ellipsis-v': true
            };
            // Determine if there will be text or just an icon
            var hasText = text != null || children != null;
            var iconProps = {
                icon: icon,
                color: iconColor,
                key: 'button__icon'
            };
            // If the button has text, apply margin right to the Icon
            if (hasText) {
                iconProps.style = { marginRight: '12px' };
            }
            // If the button has text and the icon is on the right, apply margin left to the Icon
            if (hasText && iconSide === 'right') {
                iconProps.style = { marginLeft: '12px' };
            }
            // If the button has text or the icon is a large icon, set the size to 'lg'
            if (hasText || largeIconButtons[icon]) {
                iconProps.size = 'lg';
            }
            // Consolidate all content
            var buttonChildren = [];
            if (iconSide === 'right') {
                buttonChildren = [
                    text != null && text,
                    children,
                    icon != null && React.createElement(Icon_1.default, __assign({}, iconProps))
                ];
            }
            else {
                buttonChildren = [
                    icon != null && React.createElement(Icon_1.default, __assign({}, iconProps)),
                    text != null && text,
                    children
                ];
            }
            // Return content like normal, or return it wrapped in a 0 opacity span with a progress spinner
            // 0 opacity content is to keep the button width the same
            if (loading) {
                return [
                    React.createElement("span", { style: { opacity: 0 }, key: "button__children" }, buttonChildren),
                    React.createElement(ProgressSpinner_1.default, { style: {
                            position: 'absolute',
                            left: '50%',
                            top: '50%',
                            transform: 'translate(-50%, -50%)'
                        }, key: "button__progress-spinner", size: 'extra-small', color: iconColor })
                ];
            }
            else {
                return buttonChildren;
            }
        };
        _this.prepareButtonProps = function () {
            var _a = _this.props, buttonMode = _a.buttonMode, buttonType = _a.buttonType, className = _a.className, rest = __rest(_a, ["buttonMode", "buttonType", "className"]);
            var disabled = _this.props.disabled;
            // Merge passed in classes with determined ones
            var classes = classNames('button', 'pt-intent-none', {
                'button--small': buttonMode === 'small',
                'button--text': buttonMode === 'text',
                'button--secondary': buttonType === 'secondary',
                'button--tertiary': buttonType === 'tertiary',
                'button--action': buttonType === 'action'
            }, className);
            return {
                className: classes,
                disabled: disabled,
                onClick: disabled ? undefined : _this.props.onClick
            };
        };
        return _this;
    }
    Button.prototype.componentDidMount = function () {
        monitoring_1.default('button');
    };
    Button.prototype.render = function () {
        // Pull out buttonMode and buttonType props and save the rest to pass on.
        var _a = this.props, buttonMode = _a.buttonMode, buttonType = _a.buttonType, className = _a.className, anchor = _a.anchor, rest = __rest(_a, ["buttonMode", "buttonType", "className", "anchor"]);
        if (!anchor) {
            return (React.createElement("button", __assign({ type: "button" }, pick_react_known_prop_1.pickHTMLProps(this.props), this.prepareButtonProps()), this.renderChildren()));
        }
        else {
            var buttonProps = this.prepareButtonProps();
            return (React.createElement("a", __assign({ role: "button" }, pick_react_known_prop_1.pickHTMLProps(this.props), buttonProps, { href: buttonProps.disabled ? undefined : this.props.href, tabIndex: buttonProps.disabled ? undefined : this.props.tabIndex }), this.renderChildren()));
        }
    };
    Button.defaultProps = {
        iconSide: 'left'
    };
    return Button;
}(React.Component));
exports.default = Button;
//# sourceMappingURL=Button.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/callahan-react/es/components/Button/Button.js
// module id = 59
// module chunks = 0